import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';

@Injectable({ providedIn: 'root' })
export class OkeeyCardStatusService {
  private readonly modalService = inject(NzModalService);
  private readonly translateService = inject(TranslateService);

  open(): void {
    this.modalService.info({
      nzTitle: this.translateService.instant('balance.okeeyCardPausedTitle'),
      nzContent: this.translateService.instant('balance.okeeyCardPausedDescription'),
      nzOkText: this.translateService.instant('common.close'),
      nzIconType: null,
      nzCentered: true
    });
  }
}
